import { selfAxios } from "@oppein/op-utils";
/**
 * 导出审单条件
 * @param {*} params
 * @param {*} params.orgNo 组织编码
 * @returns
 */
export async function exportReviewConditionList(params) {
  const data = await selfAxios.get(
    "/designordercenter/designUnifiedRuleController/exportReviewConditionList",
    { params, responseType: "blob" },
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/designordercenter/designUnifiedRuleController/exportReviewConditionList/get.js